import React from 'react';
import { NavLink } from 'react-router-dom';
import './Games.css';

const SpinWheels = () => {
  return(
    <div className="Games-page">
      <div className="side-bar"></div>
      <div className="Games-Container">
        <div className="games-header">
          <h1>🎡 Spin Wheels</h1>
          <p>Spin the wheels and let chance decide your fate!</p>
        </div>

        <div className="game-icon">
          <div className="game-name">
            <h3>Number Spinner</h3>
          </div>
        <div className="game-image">
         <NavLink to="/spin-wheels/number-spinner">
            <div className="professional-number-spinner-card">
              <div className="card-background">
                <div className="floating-numbers">
                  <span className="number-1">1</span>
                  <span className="number-2">12</span>
                  <span className="number-3">?</span>
                </div>
                <div className="main-icon">
                  <div className="spinner-wheel-icon">
                    <div className="wheel-segment segment-1"></div>
                    <div className="wheel-segment segment-2"></div>
                    <div className="wheel-segment segment-3"></div>
                    <div className="wheel-segment segment-4"></div>
                    <div className="wheel-center">🎲</div>
                  </div>
                </div>
                <div className="card-title">
                  <span className="title-text">Number Spinner</span>
                  <span className="subtitle">Random Number Generator</span>
                </div>
                <div className="decorative-elements">
                  <div className="dice-icon">🎯</div>
                  <div className="spin-icon">🔄</div>
                </div>
              </div>
            </div>
         </NavLink>      
        </div>      
        </div>

        <div className="game-icon">
          <div className="game-name">
            <h3>Truth or Dare Spinner</h3>
          </div>
        <div className="game-image">
         <NavLink to="/spin-wheels/truth-or-dare-spinner">
            <div className="professional-truth-dare-card">
              <div className="card-background">
                <div className="floating-elements">
                  <span className="game-element-1">❓</span>
                  <span className="game-element-2">⚡</span>
                  <span className="game-element-3">💭</span>
                </div>
                <div className="main-icon">
                  <div className="truth-dare-icon">
                    <div className="truth-side">T</div>
                    <div className="dare-side">D</div>
                    <div className="center-spinner">🎭</div>
                  </div>
                </div>
                <div className="card-title">
                  <span className="title-text">Truth or Dare</span>
                  <span className="subtitle">Party Game Fun</span>
                </div>
                <div className="decorative-elements">
                  <div className="party-icon">🎉</div>
                  <div className="question-icon">❓</div>
                </div>
              </div>
            </div>
         </NavLink>      
        </div>      
        </div>  

        <div className="game-icon">
          <div className="game-name">
            <h3>Month Spinner</h3>
          </div>
        <div className="game-image">
         <NavLink to="/spin-wheels/month-spinner">
            <div className="professional-month-spinner-card">
              <div className="card-background">
                <div className="floating-elements">
                  <span className="game-element-1">📅</span>
                  <span className="game-element-2">🗓️</span>
                  <span className="game-element-3">⏰</span>
                </div>
                <div className="main-icon">
                  <div className="month-wheel-icon">
                    <div className="month-segment segment-1">J</div>
                    <div className="month-segment segment-2">A</div>
                    <div className="month-segment segment-3">N</div>
                    <div className="month-center">📆</div>
                  </div>
                </div>
                <div className="card-title">
                  <span className="title-text">Month Spinner</span>
                  <span className="subtitle">Random Month Picker</span>
                </div>
                <div className="decorative-elements">
                  <div className="calendar-icon">📅</div>
                  <div className="time-icon">⏰</div>
                </div>
              </div>
            </div>
         </NavLink>      
        </div>      
        </div>

      </div>
      
      <div className="side-bar"></div>
    </div>
  );
}
export default SpinWheels;